import { Box, CircularProgress, SxProps, Theme } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

interface TableLoadMoreRowProps {
  loading: boolean;
  loadCallback: () => void;
  hide: boolean;
  sx?: SxProps<Theme>;
}

const TableLoadMoreRow = (props: TableLoadMoreRowProps): React.JSX.Element => {
  const { loading, loadCallback, hide, sx } = props;

  if (hide) {
    return <></>;
  }

  return (
    <Box
      sx={{
        ...sx,
        height: "100px",
        width: "100%",
        textAlign: "center",
        py: 1,
      }}
    >
      {loading ? (
        <CircularProgress
          color="secondary"
          style={{ width: "18px", height: "18px" }}
        />
      ) : (
        <RefreshIcon
          color={"secondary"}
          fontSize="large"
          onClick={loadCallback}
          sx={{ cursor: "pointer" }}
        />
      )}
    </Box>
  );
};

export default TableLoadMoreRow;
